module.exports = "./img/8114987c3cf8d667c167c10ac8ac06ce.png";